<main class="main">
  <lib-taas-main-layout titleText="EKMaaS: Operations Portal" 
    [userDetails]="taasUserService.currentuser" 
    [menuItemList]="taasMenuItemsTs"
    [activeRoute]="activeRoute" 
    (navigateHomeRequest)="navigateHome()"
    (contextMenuEvent)="handleUserContextMenuEvent($event)" 
    (routeUpdateRequest)="handleRouteUpdateRequest($event)">
    <router-outlet />
  </lib-taas-main-layout>
  <lib-taas-hidden-version-info [appVersion]="appVersion" [commonUiLibVersion]="commonUiLibVersion" />
  <lib-taas-toastr />
</main>